import PropTypes from 'prop-types'

export default {
    name: PropTypes.string,
    priority: PropTypes.number,
    date_start: PropTypes.number,
    date_end: PropTypes.number,
}
